import React from 'react';
import bizminder from '../images/bizminder.png';
import '../css/LoadingScreen.css';

const LoadingScreen = () => (
  <div>
    <div id="app-loading-logo">
      <img src={bizminder} alt="Bizminder Logo" />
    </div>
    <div className="spinner">
      <div className="rect1" />
      <div className="rect2" />
      <div className="rect3" />
      <div className="rect4" />
      <div className="rect5" />
    </div>
  </div>
);

export default LoadingScreen;



// WEBPACK FOOTER //
// ./src/pages/LoadingScreen.jsx